import { mediaBreakpointUp, paddingY } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface BreatherHeadingProps {
  text: string;
  cta?: ReactNode;
}

const BreatherHeading: FC<BreatherHeadingProps> = ({ text, cta }) => (
  <Wrapper>
    <Heading>{text}</Heading>
    {cta ? <CTAWrapper>{cta}</CTAWrapper> : null}
  </Wrapper>
);

export default BreatherHeading;

// Styled Components

const Wrapper = styled.div`
  ${paddingY(40)};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > * {
    z-index: 1;
  }

  &::before,
  &::after {
    content: '';
    z-index: 0;
    position: absolute;
  }

  ${mediaBreakpointUp('tablet')} {
    ${paddingY(60)};
  }

  ${mediaBreakpointUp('desktop')} {
    ${paddingY(80)};
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${paddingY(120)};
  }
`;

const Heading = styled.h2`
  ${customTextSize(32, 38)};
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  letter-spacing: -0.01em;
  text-align: center;
  margin-bottom: ${remCalc(40)};

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(38, 46)};
    white-space: pre-line;
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(49, 54)};
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(80, 88)};
    margin-bottom: ${remCalc(60)};
  }
`;

const CTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${mediaBreakpointUp('tablet')} {
    flex-direction: row;
  }
`;
